import { render, staticRenderFns } from "./uploadExample.vue?vue&type=template&id=13843c5c&scoped=true"
import script from "./uploadExample.vue?vue&type=script&lang=js"
export * from "./uploadExample.vue?vue&type=script&lang=js"
import style0 from "./uploadExample.vue?vue&type=style&index=0&id=13843c5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13843c5c",
  null
  
)

export default component.exports